import { Component, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, ViewContainerRef, AfterViewInit } from '@angular/core';
import { ICellEditorParams } from '@ag-grid-community/core';
import { ICellEditorAngularComp } from '@ag-grid-community/angular';

@Component({
    selector: 'p-icon-text-editor-renderer',
    template: `
        <input #input class="simple-input-editor" [(ngModel)]="value" [placeholder]="params.placeholder" />
        <p-icon class="icon-input" *ngIf="params.icon" [name]="params.icon"></p-icon>
    `,
    styleUrls: ['./icon-text-editor-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconTextEditorRendererComponent implements ICellEditorAngularComp, AfterViewInit {
    public value!: string;

    @ViewChild('input', { read: ViewContainerRef })
    public input!: ViewContainerRef;
    params!: GridCellEditorParams<any, any>;
    tempValue!: string;

    constructor(private cd: ChangeDetectorRef) {}

    ngAfterViewInit(): void {
        window.setTimeout(() => {
            this.input.element.nativeElement.focus();
        });
    }

    agInit(params: GridCellEditorParams<any, any>): void {
        this.params = params;
        this.value = this.params.value;
        this.tempValue = this.value;
    }

    getValue(): any {
        if (this.params?.cellRenderer && this.value != this.tempValue) return this.params?.cellRenderer(this.value);
        return this.value;
    }
}

export interface GridCellEditorParams<TData = any, TValue = any> extends ICellEditorParams {
    icon: string;
    existingCellMembers: [];
    placeholder: string;
    cellRenderer: (value: string) => string | undefined;
}
